import React from "react"

const Tax = () => {
  return <div>Tax</div>
}

export default Tax
